import Person from '@dc-post-grid/layout/cards/post-types/Person';
import { createApp } from 'vue';

const people = document.querySelectorAll('.page-hero .dc-post-grid-card.person-card');
if (people.length) {
	for (let i = 0; i < people.length; i++) {
		const peopleId = people[i].id;
		const personData = (typeof window['dcpg_' + peopleId] !== 'undefined') ? window['dcpg_' + peopleId] : null;
		if (personData!==null) {
			const app = createApp(Person, personData).mount('#' + peopleId);
		}
	}
}

const pageHero = document.querySelector('.page-hero');
if (pageHero) {

	const imageDiv = pageHero.querySelector('.circle-background-image');

	let pageHeroBreakpoint = pageHero.offsetHeight;
	let pageHeroIsActive = false;
	const activePageHeroClass = 'light-header-version';

	const setBreakpoints = () => {
		pageHeroBreakpoint = pageHero.offsetHeight;
	}
	
	setBreakpoints();
	window.addEventListener('resize', (e) => {
		setBreakpoints();
	})

	const toggleHeaderColoring = () => {
		if (window.scrollY>pageHeroBreakpoint) {
			if (pageHeroIsActive) {
				document.body.classList.remove(activePageHeroClass);
				pageHeroIsActive = false;
			}
			return;
		}
		if (!pageHeroIsActive) {
			document.body.classList.add(activePageHeroClass);
			pageHeroIsActive = true;
		}
	}

	toggleHeaderColoring();	
	window.addEventListener('scroll', toggleHeaderColoring)
}